module.exports = __webpack_public_path__ + "img/yandex-direct-icon.2272a798.svg";